import Image from "next/image";
import {
  Flex,
  useColorMode,
  useColorModeValue,
  Center,
} from "@chakra-ui/react";

import darkMoonLogo from "../assets/moon_dark.svg";
import lightMoonLogo from "../assets/moon_light.svg";

import sunLight from "../assets/sun_light.svg";
import sunDark from "../assets/sun_dark.svg";

const LIGHT = "light";
const DARK = "dark";

const ThemeSwitcher = () => {
  const selectedTheme = useColorModeValue(LIGHT, DARK);
  const { toggleColorMode } = useColorMode();

  return (
    <Flex
      borderRadius="32px"
      bg="#F5F5F7"
      _dark={{
        bg: "#424242",
      }}
      p="4px"
      onClick={() => toggleColorMode()}
    >
      <Center
        h="24px"
        w="24px"
        borderRadius="50%"
        bg={selectedTheme === DARK ? "#202022" : "inherit"}
      >
        <Image
          src={selectedTheme === DARK ? darkMoonLogo : lightMoonLogo}
          width="15px"
          height="15px"
          alt="dark-mode"
        />
      </Center>

      <Center
        h="24px"
        w="24px"
        borderRadius="50%"
        bg={selectedTheme === LIGHT ? "#FFFFFF" : "inherit"}
      >
        <Image
          src={selectedTheme === LIGHT ? sunLight : sunDark}
          width="15px"
          height="15px"
          alt="light-mode"
        />
      </Center>
    </Flex>
  );
};

export default ThemeSwitcher;
